// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__1Nu3S","title":"ClientCherryInfo_title__16GVc","itemText":"ClientCherryInfo_itemText__15NC-"};